import React from 'react';

export const CampPieChart = () => <div className="p-4 bg-white/50 rounded-xl text-center text-xs text-slate-500">Camp Distribution Chart</div>;
export const CampParticipationChart = () => <div className="p-4 bg-white/50 rounded-xl text-center text-xs text-slate-500">Camp Participation Chart</div>;
export const CampBMIChart = () => <div className="p-4 bg-white/50 rounded-xl text-center text-xs text-slate-500">BMI Distribution Chart</div>;
export const HealthMetricChart = () => <div className="p-4 bg-white/50 rounded-xl text-center text-xs text-slate-500 font-semibold">Health Metric Overview</div>;

export default {
  CampPieChart,
  CampParticipationChart,
  CampBMIChart,
  HealthMetricChart
};
